var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RFeedSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,6 A13,13 0,1 0,19,32 A13,13 0,1 0,19,6",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,10 A9,9 0,1 0,19,28 A9,9 0,1 0,19,10",
    fill: "#0D0D12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19,13 A6,6 0,1 0,19,25 A6,6 0,1 0,19,13",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28 L32,24 L43,35 L39,39 Z",
    fill: "#00D4FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36,12 L39,15 L36,18 L33,15 Z M8,34 L11,37 L8,40 L5,37 Z",
    fill: "#FFD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RFeedSearch);
export default __webpack_public_path__ + "static/media/p4r_feed_search.ff2a0f9a7fd24e7daa1d470d31ee0e1d.svg";
export { ForwardRef as ReactComponent };